// This is the entry point for hCaptcha JS. Add JavaScript imports here.
import './hcaptcha';
